import React from 'react';

//Third party packages
import moment from 'moment';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import UserDefinedLabels from '../../../../utils/UserDefinedLabels';
import {
  formatMemberName,
  getViewEmployeeDetails,
} from '../../../../utils/common';

import './styles/personal-info.scss';
import { maskedOther, maskedSSN } from 'src/common/masking';
import useDate from 'src/Member/utils/useDate';
import { Avatar } from '@material-ui/core';

const PersonalInfo = ({
  employeeInfo,
  loggedInMemberType,
  isReviewPage = false,
}) => {
  const { t } = useTranslation();
  const noValue = 'Not Specified';
  const { Suppress_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const {
    CertificateNumberLabel,
    AlternateID1Label,
    AlternateID2Label,
    GetDefaultMemberIDKey,
  } = UserDefinedLabels();

  const { formatDate } = useDate();

  return (
    <>
      <div className="personal-info-section">
        <div className="top-header-container">
          <div className="avarat-wrapper">
            <Avatar className="my-profile-avatar">
              {employeeInfo?.FirstName?.charAt(0).toUpperCase()}
              {employeeInfo?.LastName?.charAt(0).toUpperCase()}
            </Avatar>
          </div>
          <div className="title-age-container">
            <div className="my-profile-title">
              {formatMemberName(employeeInfo)}
            </div>
            <div className="my-profile-age">
              {'Employee' == loggedInMemberType ? 'Member' : 'Dependent'}
            </div>
          </div>
          {isReviewPage ? (
            <div className="newly-added-btn-container">
              <div className="newly-added-label">UPDATED</div>
            </div>
          ) : (
            <div className="my-profile-status">
              <div>Status</div>
              <div className="font-weight-bold">
                {employeeInfo.Status || noValue}
              </div>
            </div>
          )}
        </div>

        <div className="pt-2 member-details-container">
          <div className="first-column">
            {Suppress_Setting?.memberId !== 'hide' && (
              <div>
                <label>{CertificateNumberLabel}</label>
                <span className="plain-text ">
                  {maskedOther(
                    Suppress_Setting?.memberId
                      ? Suppress_Setting?.memberId
                      : false,
                    employeeInfo.CertificateNumber,
                  ) || noValue}
                </span>
              </div>
            )}

            <div>
              <label>{t('member.pages.my_profile.labels.dob')}</label>
              <span className="plain-text ">
                {
                  !employeeInfo.BirthDate
                    ? noValue
                    : formatDate(employeeInfo.BirthDate)
                  //moment( employeeInfo.BirthDate ).format( 'DD-MMM-YYYY' )
                }
              </span>
            </div>

            <div>
              <label>{t('member.pages.my_profile.labels.gender')}</label>
              <span className="plain-text ">
                {employeeInfo.Gender || noValue}
              </span>
            </div>

            <div>
              <label>{t('member.pages.my_profile.labels.race')}</label>
              <span className="plain-text ">
                {employeeInfo.Race || noValue}
              </span>
            </div>

            {'Employee' == loggedInMemberType && (
              <div>
                <label>
                  {t('member.pages.my_profile.labels.marital_status')}
                </label>
                <span className="plain-text ">
                  {employeeInfo.MartialStatus || noValue}
                </span>
              </div>
            )}
          </div>

          <div className="second-column">
            <div>
              <label>{t('member.pages.my_profile.labels.age')}</label>
              <span className="plain-text ">
                {(employeeInfo.Age && employeeInfo.Age + ' years') || noValue}
              </span>
            </div>

            {'Employee' == loggedInMemberType && (
              <div>
                <label>
                  {t('member.pages.my_profile.labels.no_of_dependents')}
                </label>
                <span className="plain-text ">
                  {employeeInfo.NumberOfDependents || noValue}
                </span>
              </div>
            )}

            {Suppress_Setting?.SSN !== 'hide' &&
              employeeInfo.SocialSecurityNumber && (
                <div>
                  <label>{t('member.pages.my_profile.labels.ssn')}</label>
                  <span className="plain-text ">
                    {maskedSSN(
                      Suppress_Setting?.SSN ? Suppress_Setting?.SSN : false,
                      employeeInfo.SocialSecurityNumber,
                    )}
                  </span>
                </div>
              )}

            {Suppress_Setting?.altId1 !== 'hide' && (
              <div>
                <label>{AlternateID1Label}</label>
                <span className="plain-text ">
                  {maskedOther(
                    Suppress_Setting?.altId1 ? Suppress_Setting?.altId1 : false,
                    employeeInfo.AlternateID1,
                  ) || noValue}
                </span>
              </div>
            )}

            {Suppress_Setting?.altId2 !== 'hide' && (
              <div>
                <label>{AlternateID2Label}</label>
                <span className="plain-text ">
                  {maskedOther(
                    Suppress_Setting?.altId2 ? Suppress_Setting?.altId2 : false,
                    employeeInfo.AlternateID2,
                  ) || noValue}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalInfo;
